import {
    SET_VIEW,
    SET_CATEGORY,
    MANY_BILL_PREVIEW,
    ONE_BILL_PREVIEW,
    SET_DATE
} from "@/constant/actions";
import {showMessage} from "@/views/finance/OderKids/notification";
import FnFeesService from "@/services/FinanceKids/FnFeesService";
import {nextTick} from "vue";

export const tuitionFeesStore = {
        namespaced: true,
        state: {
            view: 0,
            category: '',
            idList: [],
            dataBill: [],
            loadingBillPreview: true,
            dateSearch: new Date(),
        },
        mutations: {
            [SET_DATE](state, date) {
                state.dateSearch = date;
            },
            [SET_VIEW](state, view) {
                state.view = view;
            },
            [SET_CATEGORY](state, category) {
                state.category = category;
            },
            [MANY_BILL_PREVIEW](state, payload) {
                const {data} = payload;
                state.dataBill = data;
                if (state.dataBill.length > 0) {
                    window.open('/preview-pdf', '_blank');
                    state.loadingBillPreview = false;
                    state.idKidList = "";
                } else {
                    showMessage('Không có dữ liệu.', 'warning');
                }
            },
            [ONE_BILL_PREVIEW](state, payload) {
                const {data} = payload;
                state.dataBill = [data];
                nextTick(() => {
                    window.open('/preview-pdf', '_blank');
                });
                state.view = 1;
                state.loadingBillPreview = false;
            }
        },
        actions: {
            async [MANY_BILL_PREVIEW]({commit}, param) {
                const {view, dataInput, date} = param;
                const resp = await FnFeesService.OrderPrintMany(dataInput);
                commit(SET_DATE, date);
                commit(SET_CATEGORY, dataInput[0].category);
                commit(SET_VIEW, view);
                commit(MANY_BILL_PREVIEW, resp.data);
            },
            async [ONE_BILL_PREVIEW]({commit}, param) {
                const {idKid, category, idList, date, idOrder} = param;
                try {
                    const resp = await FnFeesService.OrderPrint(idKid, category, idList, idOrder);
                    commit(SET_CATEGORY, category);
                    commit(SET_DATE, date);
                    commit(ONE_BILL_PREVIEW, resp.data);
                } catch (err) {
                    showMessage(err.response?.data?.message || 'Lỗi không xác định', 'error');
                }
            }
        }
    }
;